<template>
  <div>
    <div class="loginPage">
      <particles class="loginParticles" />
      <div class="loginLogo">
        <img class="disableEvent" src="../../public/img/Logo-Grupo-NSC-09.png" alt="" />
      </div>
      <div class="loginCard">
          <div class="spinner" v-if="carregando && !erro"></div>
          <div v-if="!carregando">
            <div>
              <div v-if="liberado">
                <select
                  v-model="clienteId"
                  class="loginSelect"
                  @change="atualizarCliente"
                >
                  <option :value="null" selected disabled>
                    Selecione o cliente
                  </option>
                  <option
                    v-for="obj in clientes"
                    :key="obj.id"
                    :value="obj.id"
                    class="loginOptions"
                  >
                    {{ obj.cliente }}
                  </option>
                </select>
              </div>
              <login-select-usuario
                @atualizarSelecao="atualizarUsuario"
                type="text"
                icon="nc-icon nc-single-02"
                :itens="usuarios"
                :valorAtual="nomeUsuario"
                placeholder="Usuario"
                referencia="inputUsuario"
              />
              <login-input
                @atualizar-input="keyUpSenha"
                @entrar="realizarLogin"
                type="password"
                icon="nc-icon nc-key-25"
                placeholder="Senha"
                :valorAtual="senhaUsuario"
                referencia="inputSenha"
              />
              <input
                type="button"
                value="Entrar"
                class="loginBtn"
                @click="realizarLogin"
              />
            </div>
          </div>
      </div>
    </div>
    <div class="loginOculto" v-if="oculto" @keyup.esc="oculto = false">
      <div>
        <div class="loginCard">
          <div
            class="nc-icon nc-simple-remove close"
            @click="oculto = !oculto"
          ></div>
          <div>
            <login-input
              type="password"
              icon="nc-icon nc-key-25"
              placeholder="Senha"
              @atualizar-input="atualizar"
              @entrar="realizarAcesso"
            />
            <div>
              <input
                type="button"
                value="Entrar"
                class="loginBtn"
                @click="realizarAcesso"
              />
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="release" @click="loginOculto">
      {{ release }}
    </div>
  </div>
</template>

<script>
import { version } from "../../package";
import md5 from "md5";
import LoginInput from "../components/Inputs/LoginInput.vue";
import LoginSelectUsuario from "../components/Inputs/LoginSelectUsuario.vue";
import Swal from 'sweetalert2'
import { Datas } from '../lib/Helper/index';
const DEFAULT_TITLE = process.env.VUE_APP_NAME_APP;

export default {
  components: { LoginInput, LoginSelectUsuario, Swal },
  data() {
    return {
      comunicacao: null,
      release: version,
      cont: 0,
      oculto: false,
      liberado: false,
      carregando: true,
      erro: false,
      clientes: [],
      senhaUsuario: [],
      nomeCliente: "",
      clienteId: "",
      senha: "",
      nomeUsuario: "",
      loginOcultoSenha: "2cf0d35e63e1033a2263745a24760a51",
    };
  },
  methods: {
    loginOculto() {
      this.cont++;
      if (this.cont >= 2) {
        this.oculto = true;
        this.cont = 0;
      }
    },
    atualizar(payload) {
      this.senhaUsuario = payload.recebido;
    },
    atualizarUsuario(valor) {
      this.nomeUsuario = valor.recebido;
      if(this.nomeUsuario){
        localStorage.setItem("usuarioSelecionado", this.nomeUsuario)
      }
    },
    keyUpSenha(valor){
      this.senhaUsuario = valor.recebido;
      if(this.senhaUsuario){
        localStorage.setItem("senhaDigitada", this.senhaUsuario);
      }
    },
    realizarAcesso() {
      if (this.loginOcultoSenha == md5(this.senhaUsuario)) {
        this.liberado = true;
        this.oculto = false;
        localStorage.setItem("senhaUsuario", md5(this.senhaUsuario));
      }
    },
   validaCampos(){
      if(!this.nomeUsuario || this.nomeUsuario == "" || !this.senhaUsuario || this.senhaUsuario == ""){
        Swal.fire({
          title: 'Ops...',
          text: ` Por favor selecione um usaurio e senha.`,
          icon: 'info',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
        this.erro = true;
        this.carregando = false;
        return false;
      }
      this.erro = false;
      return true;
    },
    async realizarLogin(){
      let r = null;
      this.carregando = true;

      if(!this.erro){

        if(this.validaCampos()){
          this.comunicacao = await new this.$comunicacao(
            `https://unzlj900u4.execute-api.us-east-1.amazonaws.com/`,
            `basic ${process.env.VUE_APP_TOKEN_CONNECTOR_API}`
          );
          try{
            r = await this.comunicacao.send(`v1/${this.clienteId}/login`, {
                method: "POST",
                data:{
                  codigo: this.nomeUsuario,
                  senha: this.senhaUsuario
                }
            });
          }catch(error){
            if(r.status == undefined){
              console.log(error);
            }
          }

          if(r.status == 200){
            this.erro = false;
            this.carregando = false;
            localStorage.setItem("senhaUsuario", this.nomeUsuario);
            localStorage.setItem("nomeUsuario", this.senhaUsuario);
            localStorage.setItem("tokenAPI", r.data.retorno.token);
            localStorage.setItem("tokenExpira", r.data.retorno.tokenExpiraEm);
            localStorage.setItem("idCliente", this.clienteId);
            this.$router.push(`/${localStorage.getItem("nomeCliente")}/dashboard`);
            return;
          }else if(r.status == 500 || r.status == 400){
            localStorage.setItem("senhaUsuario", '');
            localStorage.setItem("nomeUsuario", '');
            this.erro = false;
            this.carregando = false;
            Swal.fire({
              title: 'Ops...',
              text: `Erro Interno no servidor!`,
              icon: 'warning',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK'
            });
          }else{
            this.erro = false;
            this.carregando = false;
            Swal.fire({
              title: 'Ops...',
              text: `Usuario ou senha invalidos!`,
              icon: 'warning',
              confirmButtonColor: '#3085d6',
              confirmButtonText: 'OK'
            });
          }
        }
      }
    },
    async puxarClientes() {
      let r = await this.comunicacao.send("v1/configuracoes/listar", {
        method: "POST",
        data: {
          filtro: {
            aplicacao: "CONNECTOR",
            nome: "CONNECTORWEB",
            entradas: [],
          },
        },
      });
      if(r.status == 200){
        this.clientes = r.data.dados;
        if(this.nomeCliente != undefined && this.clientes.find(c => c.cliente.toUpperCase() == this.nomeCliente.toUpperCase())){
          this.clienteId = this.clientes.find(c => c.cliente.toUpperCase() == this.nomeCliente.toUpperCase()).id;
        }
      }else{
       this.erro = true;
       this.carregando = false;
       Swal.fire({
          title: 'Ops...',
          text: `Não foi possivel encontrar o cliente !`,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }
    },
    async atualizarCliente() {
      localStorage.setItem("clienteAtivo", this.clienteId);
      this.comunicacao = await new this.$comunicacao(
        `https://unzlj900u4.execute-api.us-east-1.amazonaws.com/`,
        `basic ${process.env.VUE_APP_TOKEN_CONNECTOR_API}`
      );

      await this.carregarUsuarioAPI();
    },
    async carregarUsuarioAPI(){
      let r = await this.comunicacao.send(`v1/${this.clienteId}/login/listar`, {
        method: "GET",
      });
      if(r.status == 200){
        this.erro = false;
        this.usuarios = r.data.retorno;
        this.carregando = false;
      }else{
       this.erro = true;
       this.carregando = false;
       Swal.fire({
          title: 'Ops...',
          text: `Não foi possivel carregar dados de usuario!`,
          icon: 'warning',
          confirmButtonColor: '#3085d6',
          confirmButtonText: 'OK'
        });
      }
    }
  },
  async created() {
    localStorage.setItem("usuarioSelecionado", "");
    localStorage.setItem("senhaDigitada", "");

    if(localStorage.getItem("senhaUsuario") && localStorage.getItem("nomeUsuario")  && localStorage.getItem("nomeCliente")){
        this.$router.push(`/${localStorage.getItem("nomeCliente")}/dashboard`);
        return;
    }
    if (this.loginOcultoSenha == localStorage.getItem("senhaUsuario")) {
      this.liberado = true;
      this.oculto = false;
    }

    if(localStorage.getItem("tokenExpira")){
      const expirado = Datas.ValidarTempoExirado(localStorage.getItem("tokenExpira"), new Date());
      if(expirado <= 1.99){
        localStorage.setItem("senhaUsuario", "");
        localStorage.setItem("nomeUsuario", "");
        localStorage.setItem("tokenAPI", "");
        localStorage.setItem("tokenExpira", "");
        localStorage.setItem("idCliente", "");
      }
    }
    this.clienteId = localStorage.getItem("clienteAtivo");

    this.nomeCliente = this.$route.params.nomeCliente;

    if(this.$route.params.nomeCliente == undefined){
      localStorage.setItem("nomeCliente", '');
      document.title =`${DEFAULT_TITLE}`
    }else{
      localStorage.setItem("nomeCliente", this.nomeCliente);
      document.title =`${this.$route.params.nomeCliente == undefined ? '' : this.nomeCliente} - ${DEFAULT_TITLE}`
    }

    this.comunicacao = await new this.$comunicacao(
      `https://4o6ljp0xe0.execute-api.us-east-1.amazonaws.com/`,
      "ajy789345opui12erui6712hj78uy67uijh78gf7"
    );

    await this.puxarClientes();

    this.comunicacao = await new this.$comunicacao(
      `https://unzlj900u4.execute-api.us-east-1.amazonaws.com/`,
      `basic ${process.env.VUE_APP_TOKEN_CONNECTOR_API}`
    );
    await this.carregarUsuarioAPI();
  },
};
</script>
